import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function pastOrTodayDateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const raw = control.value;
    if (!raw) return null;
    const value = new Date(raw);
    if (isNaN(value.getTime())) return null;
    const today = new Date();
    today.setHours(23, 59, 59, 999);
    return value.getTime() > today.getTime() ? { futureDate: true } : null;
  };
}

export function todayISODate(): string {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}
